/**
 * Created by andreyna on 6/8/2017.
 */

const DIRECTION = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical'
}

const LAYOUT_BEHAVIOUR_CONFIG = {
    mobile: {
        vertical: {
           vouchersLayout: {
               direction: DIRECTION.HORIZONTAL,
               scrollingOptions: {
                   direction: DIRECTION.HORIZONTAL,
                   arrowsPadding: [10, 10, 10, 10],
                   itemGap: 15,
                   isArrowVisible: false,
                   swipeScroll: true,
                   isHasDots: true,
                   offset: 'center'
               }
           },
           gamesLayout: {
               direction: DIRECTION.VERTICAL,
               hasBack: false // define whether game layout has a back button. If true, this layout should be displayed at the same layout together with voucherLayout
           }
       },
        horizontal: {
           vouchersLayout: {
               direction: DIRECTION.HORIZONTAL
           },
           gamesLayout: {
               direction: DIRECTION.HORIZONTAL, //Vertical
               hasBack: true
           }
       }
    },
    pc: {
        horizontal: {
            vouchersLayout: {
                direction: DIRECTION.HORIZONTAL,
                gameMode: {
                    direction: DIRECTION.VERTICAL,
                    scrollingOptions: {
                        direction: DIRECTION.VERTICAL,
                        isArrowVisible: false,
                        itemGap: 15
                    }
                }
            },
            gamesLayout: {
                direction: DIRECTION.HORIZONTAL,
                hasBack: true
            }
        },
        vertical: {
            vouchersLayout: {
                direction: DIRECTION.HORIZONTAL,
                scrollingOptions: {
                    direction: DIRECTION.HORIZONTAL,
                    arrowsPadding: [40, 25, 20, 25],
                    itemGap: 15,
                    isArrowVisible: true,
                    swipeScroll: true,
                    isHasDots: true,
                    offset: 'center'
                },
                gameMode: {
                    direction: DIRECTION.VERTICAL,
                    scrollingOptions: {
                        direction: DIRECTION.VERTICAL,
                        arrowsPadding: [10, 0, 10, 0],
                        isArrowVisible: false,
                        itemGap: 15
                    }
                }
            },
            gamesLayout: {
                direction: DIRECTION.VERTICAL,
                hasBack: false
            }
        }
    }
}

const FP_CSS_CLASSES = {
    VOUCHERS_CONTAINER: 'cgp-fp-voucher-container-wrapper',
    GAMES_CONTAINER: 'cgp-fp-games-container-wrapper',
    DIRECTION_PREFIX: 'cgp-fp-dir-',
    FP_CONTAINER: 'cgp-fp-container',
    BACK_BTN: 'cgp-fp-voucher-back-btn-wrapper'
}

const FP_LAYOUT_STATE = {
    VOUCHERS: 'VOUCHERS',
    GAMES: 'GAMES'
}

const FP_ANALYTICS = {
    'OpenGame': {
        category: 'Client_FreePlay', //FP_Menu
        action: 'GamesMessage', //Voucher
        label: 'ChooseGame#{gameID}' //FP_Play#GameID
    },
    'VoucherInfoOpen': {
        category: 'Client_FreePlay',
        action: 'Info',
        label: 'Open'
    },
    'VoucherInfoClose': {
        category: 'Client_FreePlay',
        action: 'Info',
        label: 'Close'
    },
    'SelectVoucher': {
        category: 'Client_FreePlay',
        action: 'VouchersMessage',
        label: 'ChooseVoucher#{voucherID}'
    }
}


export {LAYOUT_BEHAVIOUR_CONFIG, FP_CSS_CLASSES, DIRECTION, FP_LAYOUT_STATE, FP_ANALYTICS};

